(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    const initCardGalleryEnhancements = () => {
  document.querySelectorAll('.card-gallery').forEach((gallery) => {
    if (gallery.dataset.cardGalleryEnhanced === 'true') return;
    gallery.dataset.cardGalleryEnhanced = 'true';

    const slideshow = gallery.querySelector('slideshow-component');
    const slideshowContainer = gallery.querySelector('slideshow-container');
    const slidesWrapper =
      gallery.querySelector('slideshow-slides') ||
      gallery.querySelector('[ref="slideshowContainer"]') ||
      gallery.querySelector('.slideshow__slides');

    const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));

    if (!slideshow || !slideshowContainer || slides.length <= 1) return;

    let progress = slideshowContainer.querySelector('.card-gallery__progress');

    if (!progress) {
      progress = document.createElement('div');
      progress.className = 'card-gallery__progress';

      const fill = document.createElement('span');
      fill.className = 'card-gallery__progress-fill';

      progress.appendChild(fill);
      slideshowContainer.appendChild(progress);
    }

    const fill = progress.querySelector('.card-gallery__progress-fill');
    let currentIndex = 0;
    let scrollTimeout = null;

    const getSlideWidth = () => {
      const firstSlide = slides[0];

      if (!firstSlide) return slideshowContainer.clientWidth || 1;

      return firstSlide.offsetWidth || slideshowContainer.clientWidth || 1;
    };

    const getIndexFromScroll = () => {
      if (!slidesWrapper) return currentIndex;

      const slideWidth = getSlideWidth();
      if (!slideWidth) return currentIndex;

      const index = Math.round(slidesWrapper.scrollLeft / slideWidth);

      return Math.max(0, Math.min(index, slides.length - 1));
    };

    const getIndexFromActiveSlide = () => {
      const activeSlide =
        gallery.querySelector('slideshow-slide[aria-hidden="false"]') ||
        gallery.querySelector('slideshow-slide[aria-current="true"]') ||
        gallery.querySelector('slideshow-slide.is-active') ||
        gallery.querySelector('slideshow-slide[active]');

      if (!activeSlide) return getIndexFromScroll();

      const index = slides.indexOf(activeSlide);

      if (index < 0) return getIndexFromScroll();

      return index;
    };

    const setProgressByIndex = (index) => {
      if (!fill) return;

      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      fill.style.width = `${((currentIndex + 1) / slides.length) * 100}%`;
    };

    const syncProgress = () => {
      setProgressByIndex(getIndexFromActiveSlide());
    };

    const syncProgressFromScroll = () => {
      setProgressByIndex(getIndexFromScroll());
    };

const smoothSnapToNearestSlide = () => {
  if (!slidesWrapper) return;

  const slideWidth = getSlideWidth();
  if (!slideWidth) return;

  const index = getIndexFromScroll();

  slidesWrapper.scrollTo({
    left: index * slideWidth,
    behavior: 'smooth'
  });

  setProgressByIndex(index);
};

    const nativePrev = gallery.querySelector('slideshow-arrows .slideshow-control--previous');
    const nativeNext = gallery.querySelector('slideshow-arrows .slideshow-control--next');

    if (gallery.dataset.cardGalleryCustomArrowsReady !== 'true') {
      gallery.dataset.cardGalleryCustomArrowsReady = 'true';

      if (nativePrev && nativeNext) {
        const prevButton = document.createElement('button');
        prevButton.type = 'button';
        prevButton.className = 'card-gallery__image-nav card-gallery__image-nav--prev';
        prevButton.setAttribute('aria-label', 'Image précédente');
        prevButton.innerHTML = `
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M15.5 4.5L8 12L15.5 19.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        `;

        const nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className = 'card-gallery__image-nav card-gallery__image-nav--next';
        nextButton.setAttribute('aria-label', 'Image suivante');
        nextButton.innerHTML = `
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M8 4.5L15.5 12L8 19.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        `;

        slideshowContainer.appendChild(prevButton);
        slideshowContainer.appendChild(nextButton);

        prevButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          nativePrev.click();

          window.setTimeout(syncProgress, 80);
          window.setTimeout(syncProgress, 250);
        });

        nextButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          nativeNext.click();

          window.setTimeout(syncProgress, 80);
          window.setTimeout(syncProgress, 250);
        });
      }
    }

    if (slidesWrapper) {
      slidesWrapper.addEventListener(
        'scroll',
        () => {
          syncProgressFromScroll();

          window.clearTimeout(scrollTimeout);

          scrollTimeout = window.setTimeout(() => {
            syncProgressFromScroll();
            syncProgress();
          }, 120);
        },
        { passive: true }
      );

slidesWrapper.addEventListener(
  'touchend',
  () => {
    window.setTimeout(smoothSnapToNearestSlide, 60);
    window.setTimeout(syncProgressFromScroll, 180);
    window.setTimeout(syncProgress, 350);
  },
  { passive: true }
);
    }

    const observer = new MutationObserver(() => {
      syncProgress();
    });

    slides.forEach((slide) => {
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'aria-current', 'class', 'active']
      });
    });

    window.addEventListener('resize', syncProgressFromScroll);

    setProgressByIndex(0);
    window.setTimeout(syncProgress, 100);
  });
};

document.addEventListener('DOMContentLoaded', initCardGalleryEnhancements);
window.addEventListener('load', initCardGalleryEnhancements);
document.addEventListener('shopify:section:load', initCardGalleryEnhancements);
document.addEventListener('product-grid:updated', initCardGalleryEnhancements);
  } catch(e) { console.error(e); }
})();

})();
